import Cookies from 'js-cookie';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

import showModal from '@/utils/show_modal';

// Иначе закрытая модалка попадёт в снимок turbolinks и оживёт при restore-визите.
$(document).on('turbolinks:before-cache', () => {
  const $modal = $('.b-modal-tariff.is-tariff-selection');
  if (!$modal.length) { return; }

  $modal.remove();
});

$(document).on('turbolinks:load', () => {
  const $modal = $('.b-modal-tariff.is-tariff-selection');
  if (!$modal.length) { return; }

  const modal = showModal({
    $modal,
    isHiddenCheck: () => !$modal.hasClass('is-active'),
    show() {
      disablePageScroll();
      $modal.addClass('is-active');
    },
    hide() {
      enablePageScroll();
      $modal.removeClass('is-active');
      rememberDismissedAgreements($modal);
    }
  });

  $modal.find('.modal-shade').on('click', modal.hide);
  $modal.find('.modal-close').on('click', modal.hide);
  $modal.find('.details').on('click', ({ currentTarget }) => {
    rememberDismissedAgreement($(currentTarget).closest('.agreement'));
  });

  modal.show();
});

function rememberDismissedAgreements($modal) {
  $modal.find('.agreement').each((_index, node) => rememberDismissedAgreement($(node)));
}

function rememberDismissedAgreement($agreement) {
  Cookies.set($agreement.data('cookie_key'), '1', { expires: 1, path: '/' });
}
